var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"800px","width":"auto"},domProps:{"innerHTML":_vm._s(_vm.poHtmlCode)}})
}
var staticRenderFns = []

export { render, staticRenderFns }